var module = angular.module('octopusApp.environments');

module.filter("cleanMachineUri", function() {
    return function(uri) {
        if (!uri || uri.length === 0) {
            return "";
        }

        uri = uri.replace("https://", "");
        uri = uri.replace("/", "");
        uri = uri.replace(":10933", "");
        return uri;
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/filters/cleanMachineUri.js
// module id = 433
// module chunks = 1